import React, { Component } from 'react';
//import {toJS} from 'mobx';
import { Button, Tooltip, Card } from '@mui/material';
import { ChevronLeft, ChevronRight, Check } from '@mui/icons-material';
import styled from 'styled-components';

//import { media } from '../../global-styles/mediaQuery';
import CardContent from './CardContent';
import { AppStates } from './FlowStore';

const toolTipDelay = 1000;

const ReviewContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: margin: 0 auto;
  height: 90vh;
  min-height: 500px;
  min-width: 430px;
  grid-row: 2/3;
  grid-column: 1/2;
`;
//  border: 1px solid gray;
//  border-radius: 10px;

  // ${media.desktop`margin: 10px;`}
  // ${media.tablet`margin: 10px;`}
  // ${media.phone`margin: 5px;`}

const ButtonContainerDiv = styled.div`
  margin: 10px;
  display: flex;
  width: 95%;
  justify-content: space-between;
`;

const StyledCard = styled(Card)`
  height: 90%;
  width: 95%;
`;

const StyledEndP = styled.p`
  margin: 10px 10px 10px 30px;
`;

class Editor extends Component {
  constructor(props) {
    super(props);
    this.store = this.props.store;
  }
  render () {
    //console.log('***************');
    //console.log(toJS(this.store.docTypes));
    return (
      <ReviewContainerDiv>
        <ButtonContainerDiv>
	  <Tooltip
	    title="Return to prior issue"
	    enterDelay={toolTipDelay} >
            <Button
              variant='contained'
              margin='dense'
              disableElevation
              startIcon={<ChevronLeft/>}
              onClick={() => { this.store.prevIssue() }} >
              Prev
            </Button>
	  </Tooltip>
          {(this.store.rejections.length > 0 &&
            this.store.currentIssue === this.store.rejections.length - 1) ||
           this.store.rejections.length === 0 ? (
	     <Tooltip
	       title="You're done, make shell documents"
	       enterDelay={toolTipDelay} >
               {/*FIXME:  Here we just include the generate documents dialog, which should be a button when
                  closed */}             
	       <Button
                 variant='contained'
                 color='primary'
                 disableElevation
                 endIcon={<Check/>}
                 onClick={() => {
                   console.log('Heading to gendocs');
                   this.store.propagateRefInfo();
                   this.store.appState = AppStates.GENDOCS;
                 }}>
                 Generate Documents
               </Button>
	     </Tooltip>
           ) : (
	     <Tooltip
	       title="Go to next issue, keep changes"
	       enterDelay={toolTipDelay} >
               <Button
                 variant='contained'
                 color='primary'
                 disableElevation
                 endIcon={<ChevronRight/>}
                 onClick={() => {
                   this.store.propagateRefInfo();
                   this.store.nextIssue();
                 }}
               >
                 Next
               </Button>
	     </Tooltip>
           )}
        </ButtonContainerDiv>
        <StyledCard variant='outlined'>
          <CardContent store={this.store}/>
        </StyledCard>
        {this.store.rejections.length !== 0 ? (
          <StyledEndP>
            If you see any issues/rejections that we haven't caught, please click on the
            line within the document and tag appropriately.
          </StyledEndP>
        ) : (
          <StyledEndP>
            Please add issues by clicking on a new piece of text in the document.
          </StyledEndP>
        )}
      </ReviewContainerDiv>
    );
  };
}

export default Editor
